import { useTranslation } from 'react-i18next'
import { NumberUtils } from '@pbt/pbt-ui-components'

import styles from './ChirpSoapChargesTableFooter.module.scss'

export interface ChirpSoapChargesTableFooterProps {
  patientName: string
  total: number
}

const ChirpSoapChargesTableFooter = ({
  patientName,
  total,
}: ChirpSoapChargesTableFooterProps) => {
  const { t } = useTranslation('Common')

  return (
    <div className={styles.footer}>
      <table className={styles.footerTable}>
        <tbody>
          <tr className={styles.footerRow}>
            <td aria-label={t('Common:EMPTY')} className={styles.footerCell} />
            <td aria-label={t('Common:EMPTY')} className={styles.footerCell} />
            <td aria-label={t('Common:EMPTY')} className={styles.footerCell} />
            <td aria-label={t('Common:EMPTY')} className={styles.footerCell} />
            <td className={styles.footerCell}>
              <div className={styles.footerContent}>
                <span className={styles.totalLabel}>
                  {t('Common:PATIENT_TOTAL_WITH_VALUE', {
                    patientName,
                    amount: NumberUtils.formatMoney(total),
                  })}
                </span>
              </div>
            </td>
            <td aria-label={t('Common:EMPTY')} className={styles.footerCell} />
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default ChirpSoapChargesTableFooter
